import React, { useState } from 'react';

import Button from 'react-bootstrap/Button';

import { VerticalSeparator, HorizontallyCenteringContainer } from './utils';

export function ButtonPickerGroup({
    options = [],
    captionText = 'Please select your desired option:',
    cancelText = 'CANCEL',
    onSelectCallback = () => null,
} = {}) {
    return (
        <>
            <HorizontallyCenteringContainer>
                {captionText}
            </HorizontallyCenteringContainer>
            <HorizontallyCenteringContainer>
                <Button
                    className="w80 swensens-button"
                    onClick={() => onSelectCallback(null)}
                >{cancelText}</Button>
            </HorizontallyCenteringContainer>
            {
                options.map((opt, idx) => (
                    <React.Fragment key={`${idx}_${opt.label}`}>
                        <VerticalSeparator height='0.2em'/>
                        <HorizontallyCenteringContainer>
                            <Button
                                className="w80 swensens-button"
                                onClick={() => onSelectCallback(opt)}
                                disabled={!!opt.disabled}
                            >{opt.label}</Button>
                        </HorizontallyCenteringContainer>
                    </React.Fragment>
                ))
            }
        </>
    )
}

export default function ButtonPickerSequence({
    buttonPickerGroups = [],
    sequenceCompletionCallback = null,
}) {
    const [buttonPickerSequenceIdx, setButtonPickerSequenceIdx] = useState(0);
    const [buttonPickerSequenceSelections, setButtonPickerSequenceSelections] = useState([]);
    const goToNextButtonPickerGroupInSequence = () => setButtonPickerSequenceIdx(currentIdx => currentIdx + 1);
    const updateSelection = (idx, opt) => setButtonPickerSequenceSelections(_currentPicks => {
        const currentPicks = [..._currentPicks];
        currentPicks[idx] = opt;
        return currentPicks;
    });

    return (
        (sequenceCompletionCallback && buttonPickerSequenceIdx < buttonPickerGroups.length) ? (
            <>
                <ButtonPickerGroup
                    {...buttonPickerGroups[buttonPickerSequenceIdx]}
                    onSelectCallback = {opt => {
                        console.log(`Selection made (index=${buttonPickerSequenceIdx}${buttonPickerGroups[buttonPickerSequenceIdx].name && ` group=${buttonPickerGroups[buttonPickerSequenceIdx].name}`}):`, opt)
                        if (!opt || buttonPickerSequenceIdx + 1 === buttonPickerGroups.length) {
                            // Submit
                            const currentPicks = [...buttonPickerSequenceSelections];
                            currentPicks[buttonPickerSequenceIdx] = opt;
                            setButtonPickerSequenceIdx(buttonPickerGroups.length)
                            sequenceCompletionCallback(!!opt ? currentPicks : null)
                        } else {
                            // Next
                            goToNextButtonPickerGroupInSequence();
                            updateSelection(buttonPickerSequenceIdx, opt);
                        }
                    }}
                />
            </>
        ) : (
            <>
            </>
        )
    )
}
